module.exports = "<p>\n  rxjs works!\n</p>\n"